import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import Chart from '../lineChart';
import { defaultSeries, defaulCategories, colorsList } from "../../const";
import loader from'../../../../assets/images/datahub-loader.svg'
import { supplierColors } from "../../const/supplierColorMapping";

const PriceTrendChart = ({
  title = 'Pricing Chart',
  series,
  categories,
  isLoading,
  expandTitleLegendGap = false,
}: {
  title?: string;
  series?: any;
  categories?: any;
  isLoading?: boolean;
  expandTitleLegendGap?: boolean;
}) => {

  const getLineColors = () => {
    // if series is missing, return a single 'black'
    if (!series) return ['black'];

    return series.map(s => {
      // uppercase ID (or undefined) then lookup; default to 'black'
      const color = supplierColors[s.supplierId?.toUpperCase()] ?? 'black';
      return color;
    });
  };

  const colorsList = getLineColors();
  if (isLoading != false) {
      return (
        <>
          <h4 className="text-center">{title}</h4>
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5" style={{ height: '400px' }}>
            <img src={loader} height={'100px'} alt="Loading" />
          </div>
          <hr/>
        </>
      );
  }

  if (!series || series.length === 0 || !categories || categories.length === 0) {
    return (
      <>
        <h4 className="text-center">{title}</h4>
        <div className="d-flex justify-content-center align-items-center mt-5 mb-5" style={{ height: '400px' }}>
          No data available for the selected filters!
        </div>
        <hr/>
      </>
    );
  }

  const options: ApexOptions = {
    chart: {
      height: '500px', // Set height to 60% of the viewport height
      width: '100%',  // Set width to 100% of the container
      // type: 'mixed',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      },
      animations: {
        enabled: false,
        easing: 'linear',
        speed: 0,
        animateGradually: { enabled: false },
        dynamicAnimation: { enabled: false, speed: 0 }
      }
    },
    colors: colorsList,
    // [
//   "#f58231", // Orange
//   "#e6194b", // Red
//   "#3cb44b", // Green
//   "#ffe119", // Yellow
//   "#0082c8", // Blue
//   "#911eb4", // Purple
//   "#46f0f0", // Cyan
//   "#f032e6", // Magenta
//   "#d2f53c", // Lime
//   "#fabebe", // Pink
//   "#008080", // Teal
//   "#e6beff", // Lavender
//   "#aa6e28", // Brown
//   "#fffac8", // Beige
//   "#800000", // Maroon
//   "#aaffc3", // Mint
//   "#808000", // Olive
//   "#ffd8b1", // Apricot
//   "#000080", // Navy
//   "#808080", // Gray
//   "#4b0082", // Indigo
//   "#b22222", // Firebrick
//   "#00ff00", // Bright Green
//   "#0000ff", // Bright Blue
//   "#ff00ff", // Bright Magenta
//   "#00ffff", // Bright Cyan
//   "#ffff00", // Bright Yellow
//   "#800080", // Dark Purple
//   "#008000", // Dark Green
//   "#ffa500"  // Dark Orange
// ],

    // [
    //   '#FEB019',
    //   '#00E396',
    //   '#008FFB',
    //   '#2F4F4F',
    //   '#8A2BE2', // BlueViolet
    //   '#20B2AA',  // LightSeaGreen
    //   '#1E90FF', // Blue
    //   '#FF6347', // Red (Tomato)
    //   '#32CD32', // Green (LimeGreen)
    //   '#8A2BE2', // BlueViolet
    //   '#FF1493', // DeepPink
    //   '#FFA500', // Orange
    //   '#FFD700', // Gold
    //   '#00FA9A', // MediumSpringGreen
    //   '#FF4500', // OrangeRed
      
    // ],
    // dataLabels: {
    //   enabled: false,
    //   formatter: function(val, opts) {
    //     console.log('formatter:', opts.w.globals.seriesNames[opts.seriesIndex]);
    //     return val + ' - ' + opts.w.globals.seriesNames[opts.seriesIndex];
    //   },
    //   style: {
    //     fontSize: '10px',
    //     colors: [
    //       '#1E90FF', // Blue
    //       '#FF6347', // Red (Tomato)
    //       '#32CD32', // Green (LimeGreen)
    //       '#8A2BE2', // BlueViolet
    //       '#FF1493', // DeepPink
    //       '#FFA500', // Orange
    //       '#FFD700', // Gold
    //       '#00FA9A', // MediumSpringGreen
    //       '#FF4500', // OrangeRed
    //       '#20B2AA'  // LightSeaGreen
    //     ]
    //   },
    // },
    stroke: {
      width: 3,
      curve: 'smooth',
      // dashArray: [0,5,5,5,5,5,5,5,5,5,5,5]
    },
    title: {
      text: title,
      align: 'center'
    },
    tooltip: {
      shared: true,
      custom: function ({ series, dataPointIndex, w }) {
        const dateLabel =
          w.globals.categoryLabels?.[dataPointIndex] ||
          w.globals.labels?.[dataPointIndex] ||
          "";

        const pricesForDate = series
          .map((seriesData, idx) => ({
            name: w.globals.seriesNames[idx],
            price: seriesData[dataPointIndex],
            color: w.config.colors?.[idx] || "#666",
            meta: w.config.series?.[idx]?.pointMeta?.[dataPointIndex] || {},
          }))
          .filter(
            (item) =>
              item.price !== null &&
              item.price !== undefined &&
              Number.isFinite(item.price)
          )
          .sort((a, b) => b.price - a.price);

        const rows = pricesForDate
          .map(
            (item) => `
              <div style="display:grid; grid-template-columns:91px 64px 46px 46px 64px 64px; align-items:center; column-gap:6px; padding:4px 0;">
                <div style="display:flex; align-items:center; gap:6px;">
                  <span style="display:inline-block;width:9px;height:9px;border-radius:50%;background:${item.color};"></span>
                  <span style="font-size:12px;color:#4a4a4a; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">${item.name}</span>
                </div>
                <span style="font-weight:600; font-size:12px; text-align:center;">${item.price.toFixed(5)}</span>
                <span style="font-size:12px; text-align:center; white-space:normal; overflow-wrap:anywhere;">${item.meta?.passThrough || "N/A"}</span>
                <span style="font-size:12px; text-align:center;">${item.meta?.count ?? "N/A"}</span>
                <span style="font-size:12px; text-align:center;">${typeof item.meta?.min === "number" ? item.meta.min.toFixed(5) : "N/A"}</span>
                <span style="font-size:12px; text-align:center;">${typeof item.meta?.max === "number" ? item.meta.max.toFixed(5) : "N/A"}</span>
              </div>
            `
          )
          .join("");

        return `
          <div style="padding:12px 14px; width:435px; border-radius:10px; background:#fff; box-shadow:0 10px 25px rgba(0,0,0,0.18); border:1px solid rgba(0,0,0,0.04);">
            <div style="font-size:12px; font-weight:700; color:#2a2a2a; margin-bottom:8px;">${dateLabel}</div>
            <div style="display:grid; grid-template-columns:91px 64px 46px 46px 64px 64px; column-gap:6px; padding:0 0 6px; margin-bottom:2px; border-bottom:1px solid rgba(0,0,0,0.08); font-size:11px; font-weight:700; color:#6b7280; text-transform:none;">
              <span style="text-align:center;">Name</span>
              <span style="text-align:center;">Avg Price</span>
              <span style="text-align:center;">#PT</span>
              <span style="text-align:center;">Count</span>
              <span style="text-align:center;">Min Price</span>
              <span style="text-align:center;">Max Price</span>
            </div>
            ${rows || "<div style='font-size:12px;color:#999;'>No data</div>"}
          </div>
        `;
      },
    },
    legend: {
      // tooltipHoverFormatter: function(val, opts) {
      //   return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
      // },
  //    tooltipHoverFormatter: function(seriesName, opts) {
  //   const dataPointIndex = opts.dataPointIndex;

  //   // Get all series and their prices for the given date index
  //   const pricesForDate = opts.w.globals.series.map((seriesData, idx) => {

  //     return {
  //       name: opts.w.globals.seriesNames[idx],   // supplier name
  //       price: seriesData[dataPointIndex]        // price on that date
  //     };
  //   });

  //   // Filter out null or undefined prices
  //   const filteredPrices = pricesForDate.filter(item => item.price != null);

  //   // Sort descending by price
  //   filteredPrices.sort((a, b) => b.price - a.price);

  //   // Format as a string with "name: price" pairs joined by <br> for new lines
  //   const formattedPrices = filteredPrices
  //     .map(item => `${item.name}: ${item.price.toFixed(5)}`)
  //     .join('<br>');

  //   return formattedPrices;
  // },
      showForSingleSeries: true,
      position: 'top',
      horizontalAlign: 'right',
      // floating: true,
      offsetY: expandTitleLegendGap ? 18 : -25,
      offsetX: -5
    },
    markers: {
      size: 4,
      colors:['#fff'],
      strokeColors: '#000000',
      strokeWidth: 1,
    },
    xaxis: {
      categories: categories,
      title: {
        text: ''
      }
    },
    yaxis: { 
      title: {
        text: 'Price ($)'
      },
      // min: 0,
      // max: 0.5,
      // tickAmount: 10
    },
    // plotOptions: {
    //   bar: {
    //     columnWidth: '75%',
    //     //distributed: true,
    //     //horizontal: false,
    //   }
    // }
  };

  return (
      <Chart options={options} series={series} height="500px"/>
  );
};

export default PriceTrendChart;
